export default "__VITE_ASSET__DWTjKdhU__"